{
  "partner": {
    "common": {
      "refresh": "Aktualisieren",
      "loadError": "Die Daten konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "adminOnlyTitle": "Nur für Partner-Admins"
    },
    "settings": {
      "adminOnlyDescription": "Die Einstellungen sind Partner-Admins vorbehalten.",
      "tabs": {
        "users": "Benutzerverwaltung"
      }
    },
    "team": {
      "inviteSuccess": "Einladung versendet",
      "inviteError": "Einladung konnte nicht versendet werden.",
      "activateSales": {
        "action": "Für Vertrieb aktivieren",
        "successCreated": "HubSpot-Kontakt erstellt und verknüpft – Nutzer kann jetzt Leads anlegen.",
        "successLinked": "Mit HubSpot-Kontakt verknüpft – Nutzer kann jetzt Leads anlegen.",
        "error": "Vertriebsaktivierung fehlgeschlagen (fehlt das HubSpot-Schreibrecht?)."
      },
      "adminOnlyDescription": "Die Nutzerverwaltung ist Partner-Admins vorbehalten.",
      "membersTitle": "Bliks-Nutzer",
      "membersEmpty": "Noch keine Nutzer.",
      "columns": {
        "name": "Name",
        "email": "E-Mail",
        "role": "Rolle",
        "status": "Status",
        "position": "Position",
        "salesStatus": "Sales-Status"
      },
      "salesStatus": {
        "active": "Aktiv für Vertrieb",
        "inactive": "Nicht aktiviert"
      },
      "addMember": "Mitglied hinzufügen",
      "dialog": {
        "createTitle": "Mitglied einladen",
        "editTitle": "Mitglied bearbeiten",
        "description": "Name, E-Mail und Rolle des Team-Mitglieds.",
        "submitCreate": "Einladen"
      },
      "createSuccess": "Einladung versendet",
      "createError": "Mitglied konnte nicht angelegt werden.",
      "updateSuccess": "Änderungen gespeichert",
      "updateError": "Änderungen konnten nicht gespeichert werden.",
      "suspendSuccess": "Mitglied gesperrt",
      "unsuspendSuccess": "Mitglied entsperrt",
      "deleteSuccess": "Mitglied entfernt",
      "deleteTitle": "Mitglied entfernen",
      "deleteDescription": "Dieses Mitglied wird dauerhaft aus dem Partner-Konto entfernt."
    },
    "home": {
      "title": "Start",
      "greeting": "Willkommen zurück, {{name}}",
      "greetingAnonymous": "Willkommen zurück",
      "subtitle": "Neuigkeiten von BLIKS IO und alles, was Sie für Ihren Vertrieb brauchen.",
      "quickLinks": "Schnellzugriff",
      "links": {
        "sales": {
          "title": "Vertrieb",
          "description": "Leads, Kontaktliste und Pipeline in der Sales-App."
        },
        "infoHub": {
          "title": "Info Hub",
          "description": "Unterlagen und Videos für Ihre Gespräche."
        }
      },
      "news": {
        "title": "Neuigkeiten",
        "empty": "Gerade gibt es keine Neuigkeiten.",
        "error": "Die Neuigkeiten konnten nicht geladen werden.",
        "pinned": "Angepinnt",
        "storyLabel": "Karussell",
        "goTo": "Neuigkeit {{index}} von {{count}}"
      },
      "recentMaterial": {
        "title": "Neu im Info Hub",
        "all": "Alle Unterlagen"
      }
    },
    "infoHub": {
      "title": "Info Hub",
      "subtitle": "Unterlagen und Videos von BLIKS IO für Ihren Vertrieb.",
      "language": "Sprache",
      "searchLanguage": "Sprache suchen …",
      "noLanguage": "Keine Sprache gefunden.",
      "search": "Unterlagen durchsuchen …",
      "category": "Kategorie",
      "categories": {
        "salesDocuments": "Verkaufsunterlagen",
        "presentations": "Präsentationen",
        "caseStudies": "Fallstudien",
        "productInfo": "Produktinformationen"
      },
      "tabs": {
        "files": "Dateien ({{count}})",
        "videos": "Videos ({{count}})"
      },
      "columns": {
        "title": "Unterlage",
        "languages": "Sprachen",
        "format": "Format"
      },
      "new": "Neu",
      "download": "Herunterladen",
      "downloadTitle": "„{{title}}“ auf {{language}} herunterladen",
      "otherLanguages": "„{{title}}“ in einer anderen Sprache herunterladen",
      "downloadIn": "Herunterladen auf",
      "downloadFailed": "Der Download konnte nicht gestartet werden.",
      "fallbackHint": "Nicht auf {{wanted}} verfügbar, Sie erhalten die Fassung auf {{language}}.",
      "playVideo": "Video „{{title}}“ abspielen",
      "empty": "Noch keine Unterlagen vorhanden.",
      "noVideos": "Noch keine Videos vorhanden.",
      "errorTitle": "Info Hub nicht verfügbar",
      "errorDescription": "Die Unterlagen konnten nicht geladen werden.",
      "availableIn": "Verfügbar auf {{languages}}",
      "moreLanguages": "+{{count}}"
    },
    "tasks": {
      "title": "Aufgaben",
      "subtitle": "Was dir übertragen wurde und noch offen ist"
    }
  }
}
